
namespace RioERP.Shipping {
    export class ShippingTrackingNumbersColumns {
        static columnsKey = 'Shipping.ShippingTrackingNumbers';
    }
}